import { FulfillmentStep } from '@/models/fulfillment-step';

export class FulfilmentProcess {
	public constructor(public readonly steps: FulfillmentStep[]) {}
}
